import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pr-2" }
const _hoisted_2 = { class: "w-[80%] h-[40rem] self-center" }
const _hoisted_3 = { class: "text-v_dark_blue" }
const _hoisted_4 = { class: "font-[700] mt-2 w-full" }
const _hoisted_5 = {
  key: 0,
  class: "text-v_red text-center"
}
const _hoisted_6 = {
  key: 1,
  class: "text-v_green text-center"
}
const _hoisted_7 = { class: "mt-10 flex justify-between items-center" }

import { ref } from "vue"
import {
	ModalContainer,
	H1,
	H2,
	Input,
	ModalCloseButton,
	ModalButton,
	ModalContentContainer,
} from "../atoms"
import { recoveryPassword } from "@/repositories/recoveryPassword"
import { onMounted } from "vue"
import { useStore } from "@/store"


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalChangePassword',
  emits: ["showLoading"],
  setup(__props, { emit }) {



let username: any = ref("")
let validationError = ref(false)
let sucess = ref(false)

const store = useStore()

const changePassword = async () => {
	emit("showLoading", true)
	const res: any = await recoveryPassword(username.value)

	if (res?.status == 204) {
		sucess.value = true
	} else {
		validationError.value = true
	}
	emit("showLoading", false)
}

onMounted(async () => {
	const user = store.getters.getUsername

	username.value = user
})

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createBlock(_unref(ModalContainer), null, {
    default: _withCtx(() => [
      _createVNode(_unref(ModalContentContainer), {
        w: "33.30rem",
        h: "26rem",
        height: 23
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("button", {
              class: "float-right w-8 px-2 py-2 active:scale-90",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('closeModalChangePassword', false)))
            }, [
              _createVNode(_component_v_icon, { icon: "mdi-close-thick" })
            ])
          ]),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_unref(H1), null, {
                default: _withCtx(() => [
                  _createTextVNode("Trocar senha")
                ]),
                _: 1
              }),
              _createVNode(_unref(H2), { class: "text-black opacity-[50%] text-left" }, {
                default: _withCtx(() => [
                  _createTextVNode(" Enviaremos um link para o seu email para redefinição de senha. ")
                ]),
                _: 1
              })
            ]),
            _createVNode(_unref(Input), {
              value: _unref(username),
              class: "text-v_dark_blue mt-4",
              w: "26.5rem",
              disabled: true
            }, null, 8, ["value"]),
            _createElementVNode("div", _hoisted_4, [
              (_unref(validationError))
                ? (_openBlock(), _createElementBlock("p", _hoisted_5, " Username incorreto. Tente novamente! "))
                : _createCommentVNode("", true),
              (_unref(sucess))
                ? (_openBlock(), _createElementBlock("p", _hoisted_6, " Você receberá um email para redefinição de senha "))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_unref(ModalCloseButton), {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('closeModalChangePassword', false))),
                class: "active:scale-90",
                w: "12.12rem"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Fechar ")
                ]),
                _: 1
              }),
              _createVNode(_unref(ModalButton), {
                enableButton: true,
                class: "active:scale-90",
                w: "12.12rem",
                onClick: changePassword
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Confirmar ")
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})